import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTieredStopChargesTableList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceTieredChargeTableLookup: DataSource;
    tableTieredStopChargesTables: Table;
}
